/* RESPONSIBLE TEAM: team-app-security */
import Model, { attr, hasMany } from '@ember-data/model';

export default class ScimUser extends Model {
  @attr('string') declare userName: string;
  @attr('boolean') declare active: boolean;
  @attr('string') declare displayName: string;
  @attr() declare emails: Array<{
    display: string;
    primary: boolean;
    type: string;
    value: string;
  }>;
  @attr() declare name: {
    formatted: string;
    givenName: string;
    familyName: string;
  };
  @hasMany('scim-group', { async: false }) declare groups: import('./scim-group').default[];
}
